class Selector {
  constructor(select, observable, eventName) {
    this.observable = observable;
    this.select = select;
    this.eventName = eventName;

    this.selected = this.selected.bind(this);
  }

  init(items, dict) {
    this.createOptions(items, dict);
    this.bindEventListeners();
  }

  bindEventListeners() {
    this.select.addEventListener('change', this.selected);
  }

  createOptions(items, dict) {
    for (let i = 0, len = items.length;  i < len; i++) {
      const opt = document.createElement('option');

      opt.value = items[i][dict.value];
      opt.text = items[i][dict.text];

      this.select.appendChild(opt);
    }
  }

  selected() {
    const value = this.getValue();
    this.observable.publish(this.eventName, value);
  }

  update(value) {
    this.select.value = value;
  }

  getValue() {
    return this.select.value;
  }

  reset() {
    this.select.selectedIndex = 0; // first option is selected
  }
}

export default Selector;